var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_in_full_black_24dp",
    transform: "translate(0 -0.247)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1928",
    "data-name": "Rectangle 1928",
    width: 41,
    height: 41,
    transform: "translate(0 0.247)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M33.757,16.67V3H20.087l5.622,5.622L8.622,25.709,3,20.087v13.67H16.67l-5.622-5.622L28.135,11.048Z",
    transform: "translate(2.126 2.364)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.932313a9.svg";
export { ForwardRef as ReactComponent };